import { Select } from "antd";
import classNames from "classnames";
import { MdCheck, MdLock, MdPriorityHigh } from "react-icons/md";
import Label from "shared/components/Label";

const Simple = ({
  label,
  errors,
  icon,
  labelSuffix,
  touched,
  required,
  direction,
  optional,
  optionFilterProp = "label",
  theme,
  success,
  showSuccessIcon = true,
  className,
  ...rest
}) => {
  const hasValue = Array.isArray(rest.value)
    ? rest.value.length > 0
    : rest.value !== undefined && rest.value !== null && `${rest.value}` !== "";

  return (
    <div
      className={classNames(
        "select__wrapper",
        {
          __error: touched && errors,
          __success: success && !errors,
        },
        direction,
        theme,
      )}
    >
      <Label
        label={label}
        icon={icon}
        labelSuffix={labelSuffix}
        required={required}
        optional={optional}
      />
      <div className={`select__wrapper--field`}>
        <Select
          size="large"
          className={classNames(className, {
            "disable--input": rest.disabled,
            "select--filled": hasValue,
          })}
          optionFilterProp={optionFilterProp}
          {...rest}
        />

        {/* Icône d'erreur */}
        {touched && errors && (
          <MdPriorityHigh className="input--error-icon" size={20} />
        )}

        {/* Icône de succès */}
        {success && showSuccessIcon && !errors && (
          <MdCheck className="input--success-icon" size={20} />
        )}

        {/* Icône cadenas pour disabled */}
        {rest.disabled && !touched && (
          <MdLock className="input--disabled-icon" size={16} />
        )}
      </div>
      {touched && errors && <p className={"input--errors"}>{errors}</p>}
    </div>
  );
};

export default Simple;
